import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  root: {
    background: '#EEEEEE',
    border: '1px solid #E0E0E0',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: 16,
  },
  deleteBtn: {
    cursor: 'pointer',
    '&:hover': {
      color: '#dc3f53',
    },
  },
  deleteIcon: {
    fontSize: 24,
  },
  actions: {
    marginTop: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));
